
"use strict";

var zeropadnum = require('../zeropadnum');

var MILLISECONDS_IN_A_MINUTE = 60 * 1000
  , MILLISECONDS_IN_AN_HOUR = 60 * MILLISECONDS_IN_A_MINUTE
  , iso8601DateTimeRe = new RegExp('^(####|\\d{4})(?:' + 
          '-?(###|\\d{3})|' + 
          '-?W(##|\\d{2})(?:-?([1-8#]))?|' +
          '(?:-?(##|\\d{2})(?:-?(##|\\d{2}))?)?)' +
        '(?:T(##|\\d{2}):?(##|\\d{2})(?::?(##|\\d{2})(\\.(?:#{1,9}|\\d{1,9}))?)?' +
        '(Z|[-+]\\d{2}(?::?\\d{2})?)?)?$')
  , dateparts = ['year', 'oday', 'week', 'wday', 'month', 'mday', 'hour', 'minute', 'second', 'fraction', 'timezone']
  , defaultParts = {
    month: 1,
    mday: 1,
    hour: 0,
    minute: 0,
    second: 0
  };

/*
  a `date` may be:

   - undefined
   - a RelativeDate instance (passed or cloned)
   - a Date instance
   - iso8601 string with # placeholders
   - number of milliseconds

   constructor form will always return a new object
*/

function RelativeDate(date) {
  var value;

  if (!(this instanceof RelativeDate)) {
    if (date instanceof RelativeDate) return date;
    return new RelativeDate(date);
  }

  if ('number' === typeof date) {
    if (!isFinite(date)) {
      throw new TypeError('date given as a number of milliseconds must be finite');
    }
    date = new Date(date);
  }

  if (date instanceof RelativeDate) {
    this.year = date.year;
    value = date.oday;
    if (value !== undefined) this.oday = value;
    value = date.week;
    if (value !== undefined) this.week = value;
    value = date.wday;
    if (value !== undefined) this.wday = value;
    this.month = date.month;
    this.mday = date.mday;
    this.hour = date.hour;
    this.minute = date.minute;    
    this.second = date.second;
    value = date.fraction;
    if (value !== undefined) this.fraction = value;
    value = date.timezone;
    if (value !== undefined) this.timezone = value;
    this.relative = date.relative;
  }
  else if (date instanceof Date) {
    parseDateObject(this, date);
  }
  else if ('string' === typeof date) {
    parseDateTime(this, date);
    this.source = date;
  }
  else if (date !== null && isFinite(date = +date)) {
    parseDateObject(this, new Date(date));
  }
  else {
    throw new TypeError('date argument must be a string, number, Date or RelativeDate instances');
  }
}

RelativeDate.prototype.toJSON = function() {
  return this.toString();
};

RelativeDate.prototype.toString = function(force) {
  var value = this.source;
  if (value !== undefined && !force) return value;

  var datestr = hashorpadnum(this.year, 4);

  if ((value = this.oday) !== undefined) {
    datestr += '-' + hashorpadnum(value, 3);
  }
  else if ((value = this.week) !== undefined) {
    datestr += '-W' + hashorpadnum(value, 2);
    value = this.wday;
    if (value === undefined) value = 1;
    else if (value === null) value = '#';
    datestr += '-' + value;
  }
  else {
    datestr += '-' + hashorpadnum(this.month, 2) +
               '-' + hashorpadnum(this.mday, 2);
  }
  datestr += 'T' + hashorpadnum(this.hour, 2) +
             ':' + hashorpadnum(this.minute, 2) +
             ':' + hashorpadnum(this.second, 2);
  if ((value = this.fraction) !== undefined) {
    if (value === null) value = '.###';
    datestr += value;
  }
  if ((value = this.timezone) !== undefined) {
    datestr += value;
  }

  this.source || (this.source = datestr);
  return datestr;
};

RelativeDate.prototype.isLocal = function() {
  return this.timezone == null;
};

RelativeDate.prototype.toSubtractedDurationDate = function(duration, refdate) {
  var date, msoffset
    , timezone = this.timezone;

  if (timezone == null) {
    return duration.subtractFromDate(this.toDate(refdate));
  }
  else { /* adjust then zonify */
    msoffset = getTimeZoneMSOffset(timezone);
    if (this.relative) refdate = normalizeDateWithOffset(refdate, msoffset);
    date = duration.subtractFromUTCDate(this.toDate(refdate, 0));
    if (msoffset !== 0) date.setUTCMilliseconds(date.getUTCMilliseconds() - msoffset);
    return date;
  }
};

RelativeDate.prototype.toAddedDurationDate = function(duration, refdate) {
  var date, msoffset
    , timezone = this.timezone;

  if (timezone == null) {
    return duration.addToDate(this.toDate(refdate));
  }
  else { /* adjust then zonify */
    msoffset = getTimeZoneMSOffset(timezone);
    if (this.relative) refdate = normalizeDateWithOffset(refdate, msoffset);
    date = duration.addToUTCDate(this.toDate(refdate, 0));
    if (msoffset !== 0) date.setUTCMilliseconds(date.getUTCMilliseconds() - msoffset);
    return date;
  }
};

RelativeDate.prototype.toDate = function(refdate, timezone) {
  var value, date, msoffset
    , year = this.year
    , hour = this.hour, minute = this.minute, second = this.second;

  if (timezone === undefined) timezone = this.timezone;

  if (timezone == null) {
    if (this.relative) refdate = normalizeDateWithOffset(refdate, 0);

    if (year === null) year = refdate.getFullYear();
    if (hour === null) hour = refdate.getHours();
    if (minute === null) minute = refdate.getMinutes();
    if (second === null) second = refdate.getSeconds();

    if ((value = this.oday) !== undefined) {
      if (value === null) {
        date = new Date(year, refdate.getMonth(), refdate.getDate(), hour, minute, second);
      }
      else date = new Date(year, 0, value, hour, minute, second);
    }
    else if ((value = this.week) !== undefined) {
      if (value === null) {
        date = new Date(year, refdate.getMonth(), refdate.getDate(), hour, minute, second);
      } else {
        date = new Date(year, 0, 4 + (value - 1) * 7, hour, minute, second);
      }

      value = this.wday;
      if (value === undefined) value = 1;
      else if (value === null) value = refdate.getDay() || 7;
      value = value - (date.getDay() || 7);
      if (value !== 0) {
        date.setDate(date.getDate() + value);
      }
    }
    else {
      var month = this.month, mday = this.mday;
      if (month === null) month = refdate.getMonth() + 1;
      if (mday === null) mday = refdate.getDate();
      date = new Date(year, month - 1, mday, hour, minute, second);
    }
    value = this.fraction;
    if (value !== undefined) {
      date.setMilliseconds(value === null ? refdate.getMilliseconds()
                                          : parseFloat(value) * 1000);
    }
  }
  else {
    msoffset = 'number' === typeof timezone ? timezone
                                            : getTimeZoneMSOffset(timezone);
    if (this.relative) refdate = normalizeDateWithOffset(refdate, msoffset);

    if (year === null) year = refdate.getUTCFullYear();
    if (hour === null) hour = refdate.getUTCHours();
    if (minute === null) minute = refdate.getUTCMinutes();
    if (second === null) second = refdate.getUTCSeconds();

    if ((value = this.oday) !== undefined) {
      if (value === null) {
        date = new Date(Date.UTC(year, refdate.getUTCMonth(), refdate.getUTCDate(), hour, minute, second) - msoffset);
      }
      else date = new Date(Date.UTC(year, 0, value, hour, minute, second) - msoffset);
    }
    else if ((value = this.week) !== undefined) {
      if (value === null) {
        date = new Date(Date.UTC(year, refdate.getUTCMonth(), refdate.getUTCDate(), hour, minute, second));
      } else {
        date = new Date(Date.UTC(year, 0, 4 + (value - 1) * 7, hour, minute, second));
      }

      value = this.wday;
      if (value === undefined) value = 1;
      else if (value === null) value = refdate.getUTCDay() || 7;
      value = value - (date.getUTCDay() || 7);
      if (value !== 0) {
        date.setUTCDate(date.getUTCDate() + value);
      }
      if (msoffset !== 0) {
        date.setUTCMilliseconds(date.getUTCMilliseconds() - msoffset);
      }
    }
    else {
      var month = this.month, mday = this.mday;
      if (month === null) month = refdate.getUTCMonth() + 1;
      if (mday === null) mday = refdate.getUTCDate();
      date = new Date(Date.UTC(year, month - 1, mday, hour, minute, second) - msoffset);
    }

    value = this.fraction;
    if (value !== undefined) {
      date.setUTCMilliseconds(value === null ? refdate.getUTCMilliseconds() : parseFloat(value) * 1000);
    }
  }

  return date;
};

function parseDateObject(relativedate, date) {
  var value = (date.getUTCMilliseconds() / 1000).toString().substr(1);
  if (value) relativedate.fraction = value;
  relativedate.year = date.getUTCFullYear();
  relativedate.month = date.getUTCMonth() + 1;
  relativedate.mday = date.getUTCDate();
  relativedate.hour = date.getUTCHours();
  relativedate.minute = date.getUTCMinutes();
  relativedate.second = date.getUTCSeconds();
  relativedate.timezone = 'Z';
  relativedate.relative = false;
}

function parseDateTime(relativedate, value) {
  var partname
    , relative = false
    , result = value.match(iso8601DateTimeRe);

  if (result === null) {
    throw new TypeError('Invalid ISO8601 date format: "' + value + '"');
  }

  for(var i = 1, len = result.length - 2; i < len; ++i) {
    partname = dateparts[i - 1];
    value = result[i];
    if (value !== undefined) {
      value = parseFloat(value);
      if (isNaN(value)) {
        /* set placeholder to null */
        value = null;
        relative = true;
      }
      relativedate[partname] = value;
    }
    else {
      value = defaultParts[partname];
      if (value !== undefined) relativedate[partname] = value;
    }
  }

  for (len += 2; i < len; ++i) {
    partname = dateparts[i - 1];
    value = result[i];
    if (value !== undefined) {
      if (value[1] === '#') {
        /* set placeholder to null */
        value = null;
        relative = true;
      }
      relativedate[partname] = value;
    }
  }

  relativedate.relative = relative;
}

var hashpad = '####';

function hashorpadnum(value, size) {
  if (value === null) {
    return hashpad.substr(0, size);
  }
  else return zeropadnum(value, size);
}

function getTimeZoneMSOffset(timezone) {
  var value, minutes;

  switch(timezone) {
    case 'Z':
    case '+00': case '-00':
    case '+0000': case '-0000':
    case '+00:00': case '-00:00':
      return 0;
  }

  switch(timezone.length) {
    case 3:
      return parseInt(timezone) * MILLISECONDS_IN_AN_HOUR;
    case 5:
      minutes = parseInt(timezone.substr(3));
      break;
    case 6:
      minutes = parseInt(timezone.substr(4));
      break;
    default:
      throw new Error('invalid ISO timezone');
  }

  value = parseInt(timezone.substr(0, 3)) * MILLISECONDS_IN_AN_HOUR;
  if (value < 0) minutes = -minutes;
  return value + minutes * MILLISECONDS_IN_A_MINUTE;
}

function normalizeDateWithOffset(date, msoffset) {
  if (msoffset !== 0) {
    if (date == null) {
      date = new Date(Date.now() + msoffset);
    }
    else {
      if ('number' === typeof date) {
        date = new Date(date + msoffset);
      }
      else {
        if (!(date instanceof Date)) date = new Date(date);
        date = new Date(date.getTime() + msoffset);
      }
    }
  } else {
    if (date == null) {
      date = new Date();
    }
    else if (!(date instanceof Date)) {
      date = new Date(date);
    }
  }
  return date;
}

module.exports = RelativeDate;
